import * as React from 'react';
import * as Colors from '../../../consts/variables';

interface IProps {
    icon: string;
    text: string;
}

export class Exclusive extends React.Component<IProps, any> {
    styles: any = {
        wrapper: { height: '25px', width: 'inherit', textAlign: 'left', display: 'flex' },
        icon: { height: '18px', width: '18px' },
        text: {
            color: Colors.lightGreen,
            fontSize: '13px',
            fontWeight: 'bold',
            marginLeft: '10px',
            height: '18px',
            alignSelf: 'center',
        },
    };

    render() {
        const { text, icon } = this.props;
        return (
            <div style={this.styles.wrapper}>
                <img style={this.styles.icon} src={icon} alt={text} />
                <span style={this.styles.text}>{text}</span>
            </div>
        );
    }
}
